import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("ID")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("First name")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Last name")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Email")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Job title")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Preferred language")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Organization")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Marketing communication")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_members_editable_field_first_name = _resolveComponent("members-editable-field-first-name")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_members_editable_field_last_name = _resolveComponent("members-editable-field-last-name")!
  const _component_members_editable_field_email = _resolveComponent("members-editable-field-email")!
  const _component_members_editable_field_job_title = _resolveComponent("members-editable-field-job-title")!
  const _component_members_editable_field_preferred_language = _resolveComponent("members-editable-field-preferred-language")!
  const _component_members_editable_field_organization = _resolveComponent("members-editable-field-organization")!
  const _component_members_editable_field_allow_marketing = _resolveComponent("members-editable-field-allow-marketing")!
  const _component_q_list = _resolveComponent("q-list")!

  return (_openBlock(), _createBlock(_component_q_list, {
    class: "q-mb-lg",
    bordered: "",
    padding: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_item, null, {
        default: _withCtx(() => [
          _createVNode(_component_q_item_section, { class: "col-lg-2 col-3 text-right text-weight-medium" }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          }),
          _createVNode(_component_q_item_section, { class: "q-pl-lg" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.memberPersonalInfoModel.memberId), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_q_item, null, {
        default: _withCtx(() => [
          _createVNode(_component_q_item_section, { class: "col-lg-2 col-3 text-right text-weight-medium" }, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          }),
          _createVNode(_component_q_item_section, { class: "q-pl-lg" }, {
            default: _withCtx(() => [
              _createVNode(_component_members_editable_field_first_name, {
                modelValue: _ctx.memberPersonalInfoModel.firstName,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.memberPersonalInfoModel.firstName) = $event)),
                lastName: _ctx.memberPersonalInfoModel.lastName
              }, null, 8, ["modelValue", "lastName"])
            ]),
            _: 1
          }),
          _createVNode(_component_q_item_section, { avatar: "" }, {
            default: _withCtx(() => [
              _createVNode(_component_q_item_label, { caption: "" }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_btn, {
                    label: "Change password",
                    onClick: _ctx.onChangePassword,
                    color: "primary",
                    unelevated: "",
                    "no-caps": ""
                  }, null, 8, ["onClick"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_q_item, null, {
        default: _withCtx(() => [
          _createVNode(_component_q_item_section, { class: "col-lg-2 col-3 text-right text-weight-medium" }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          }),
          _createVNode(_component_q_item_section, { class: "q-pl-lg" }, {
            default: _withCtx(() => [
              _createVNode(_component_members_editable_field_last_name, {
                modelValue: _ctx.memberPersonalInfoModel.lastName,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.memberPersonalInfoModel.lastName) = $event)),
                firstName: _ctx.memberPersonalInfoModel.firstName
              }, null, 8, ["modelValue", "firstName"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_q_item, null, {
        default: _withCtx(() => [
          _createVNode(_component_q_item_section, { class: "col-lg-2 col-3 text-right text-weight-medium" }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          }),
          _createVNode(_component_q_item_section, { class: "q-pl-lg" }, {
            default: _withCtx(() => [
              _createVNode(_component_members_editable_field_email, {
                modelValue: _ctx.memberPersonalInfoModel.email,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.memberPersonalInfoModel.email) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_q_item, null, {
        default: _withCtx(() => [
          _createVNode(_component_q_item_section, { class: "col-lg-2 col-3 text-right text-weight-medium" }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          }),
          _createVNode(_component_q_item_section, { class: "q-pl-lg" }, {
            default: _withCtx(() => [
              _createVNode(_component_members_editable_field_job_title, {
                modelValue: _ctx.memberPersonalInfoModel.jobTitleId,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.memberPersonalInfoModel.jobTitleId) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_q_item, null, {
        default: _withCtx(() => [
          _createVNode(_component_q_item_section, { class: "col-lg-2 col-3 text-right text-weight-medium" }, {
            default: _withCtx(() => [
              _hoisted_6
            ]),
            _: 1
          }),
          _createVNode(_component_q_item_section, { class: "q-pl-lg" }, {
            default: _withCtx(() => [
              _createVNode(_component_members_editable_field_preferred_language, {
                modelValue: _ctx.memberPersonalInfoModel.preferredLanguage,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.memberPersonalInfoModel.preferredLanguage) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_q_item, null, {
        default: _withCtx(() => [
          _createVNode(_component_q_item_section, { class: "col-lg-2 col-3 text-right text-weight-medium" }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          }),
          _createVNode(_component_q_item_section, { class: "q-pl-lg" }, {
            default: _withCtx(() => [
              _createVNode(_component_members_editable_field_organization, {
                modelValue: _ctx.memberPersonalInfoModel.organizationId,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.memberPersonalInfoModel.organizationId) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_q_item, null, {
        default: _withCtx(() => [
          _createVNode(_component_q_item_section, { class: "col-lg-2 col-3 text-right text-weight-medium" }, {
            default: _withCtx(() => [
              _hoisted_8
            ]),
            _: 1
          }),
          _createVNode(_component_q_item_section, { class: "q-pl-lg" }, {
            default: _withCtx(() => [
              _createVNode(_component_members_editable_field_allow_marketing, {
                modelValue: _ctx.memberPersonalInfoModel.allowMarketingCommunication,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.memberPersonalInfoModel.allowMarketingCommunication) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}